<template>
  <div class="page">
        <!-- 搜索 -->
  <el-form v-if="isSearch" :model="queryForm" ref="form" label-width="80px" :inline="true" size="small" class="query-form" @submit.native.prevent>
              <el-form-item label="用户">
<!--                  <el-input style='width: 177px;' v-model="queryForm.userId"></el-input>-->
                  <GridSelectU style="width: 177px;" labelName="userName" labelValue="id"
                               :value="queryForm.userId" :limit='1' size='small' placeholder='请选择用户' @getValue="getSeacherValueUser" :columns="USER_code" :searchs="USER_search" dataListUrl="/mpp/user/findList" entityBeanName="mppUser" queryEntityUrl="/mpp/user/get">
                  </GridSelectU>
              </el-form-item>
              <el-form-item label="视频">
<!--                  <el-input style='width: 177px;' v-model="queryForm.videoId"></el-input>-->
                  <GridSelectVideo style="width: 177px;" labelName="videoDesc" labelValue="id"
                                   :value="queryForm.videoId" :limit='1' size='small' placeholder='请选择视频' @getValue="getSeachValueVideo" :columns="VIDEO_code" :searchs="VIDEO_search" dataListUrl="/video/video/findList" entityBeanName="videoVideo" queryEntityUrl="/video/video/get">
                  </GridSelectVideo>
              </el-form-item>
              <el-form-item>
                  <el-button size="small" type="primary" icon="el-icon-search" @click="getVideoCollectionList">查询</el-button>
                  <el-button size="small" icon="el-icon-refresh" @click="resetDialog">重置</el-button>
              </el-form-item>
  </el-form>
  <div class="page-content">
    <div class="page-tool-bar">
      <div class="el-btn-group">
        <el-button
          type="primary"
          size="small"
          icon="el-icon-plus"
          @click="addVideoCollection"
        >新建</el-button>
        <el-button
          type="warning"
          plain
          size="small"
          icon="el-icon-edit"
          :disabled="multipleSelection.length != 1"
          @click="editVideoCollection(null)"
        >修改</el-button>
        <el-button
          type="danger"
          plain
          size="small"
          icon="el-icon-delete"
          :disabled="multipleSelection.length <= 0"
          @click="deleteVideoCollection(null)"
        >删除</el-button>
      </div>

      <div class="icon-group">
            <el-upload v-if="this.isImportDate"
              class="upload-demo"
              action="#"
                            :http-request="upload"
              :show-file-list="true">
              <el-button size="small" type="primary">点击上传</el-button>
              <div slot="tip" class="el-upload__tip">只允许导入“xls”或“xlsx”格式文件！</div>
            </el-upload>
        <span
          title="搜索"
          class="icon-box"
          @click="search"
        >
          <Icon color="#606266">
            <Search />
          </Icon>
        </span>
<!--        <span-->
<!--          title="下载模板"-->
<!--          class="icon-box"-->
<!--          @click="importTemplate"-->
<!--        >-->
<!--          <Icon color="#606266">-->
<!--            <ArrowDown />-->
<!--          </Icon>-->
<!--        </span>-->
<!--        <span-->
<!--          class="icon-box"-->
<!--          title="导入数据"-->
<!--          @click="isImport"-->
<!--        >-->
<!--          <Icon color="#606266">-->
<!--            <ArrowExportUp24Regular />-->
<!--          </Icon>-->
<!--        </span>-->
<!--        <span-->
<!--          title="导出数据"-->
<!--          class="icon-box"-->
<!--          @click="exportVideoCollectionList"-->
<!--        >-->
<!--          <Icon color="#606266">-->
<!--            <ArrowDownload24Regular />-->
<!--          </Icon>-->
<!--        </span>-->
        <span
          class="icon-box"
          @click="refreshVideoCollectionList"
        >
          <Icon color="#606266">
            <Refresh />
          </Icon>
        </span>
      </div>
    </div>
          <!-- 列表数据 -->
    <el-table
      :data="videoCollectionList"
      row-key="id"
      border
      height="100%"
      :header-row-style="{height: '10px'}"
      :header-cell-style="{padding: '10px'}"
      :row-style="{height: '9px'}"
      :cell-style="{padding: '9px'}"
      @selection-change="handleSelectionChange"
      size="samll"
    >
      <el-table-column
        align="center"
        type="selection"
        width="60"
      > </el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        prop="userId"
        label="用户"
      >
          <template slot-scope="scope">
              <div v-if="scope.row.user">
                  <div style="text-align: left">账号：{{ scope.row.user.userName }}</div>
                  <div style="text-align: left">手机：{{ scope.row.user.userMobile }}</div>
                  <div style="text-align: left">昵称：{{ scope.row.user.userNickname }}</div>
                  <div style="text-align: left">姓名：{{ scope.row.user.userRealname }}</div>
              </div>
              <div v-else>--</div>
          </template>
      </el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        prop="videoId"
        label="视频"
      >
          <template slot-scope="scope">
              <div v-if="scope.row.video">
                  <span>{{ scope.row.video.videoDesc }}</span>
              </div>
              <div v-else>--</div>
          </template>
      </el-table-column>
      <el-table-column
        fixed="right"
        align="center"
        label="操作"
        width="300"
      >
        <template slot-scope="scop">
          <div class="operation">
            <div @click="checkVideoCollection(scop.row.id)">
              <Icon size="16">
                <Eye24Regular />
              </Icon>
              <span class="operation-label">查看</span>
            </div>
            <div @click="editVideoCollection(scop.row.id)">
              <Icon size="16">
                <Edit24Regular />
              </Icon>
              <span class="operation-label">修改</span>
            </div>
            <div @click="deleteVideoCollection(scop.row.id)">
              <Icon size="16" style="color: red">
                <Delete24Regular />
              </Icon>
              <span class="operation-label" style="color: red">删除</span>
            </div>
          </div>
        </template>
      </el-table-column>
    </el-table>
    <div class="pagination-box">
      <el-pagination
        @size-change="sizeChange"
        @current-change="currentChange"
        :current-page.sync="currentPage"
        :page-sizes="[10, 20, 50, 100]"
        :page-size="pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="totalNum"
        background
        :pager-count="7"
      >
      </el-pagination>
    </div>
    <!-- 新增/查看/修改信息 -->
    <el-dialog
      :title="videoCollectionStates[videoCollectionState]"
      :visible.sync="showDialog"
      width="60%"
      @close="closeDialog"
    >
      <div>
        <el-form
          :model="videoCollection"
          ref="videoCollectionForm"
          :rules="rules"
          label-width="120px"
          :inline="true"
          size="small"
        >
          <el-form-item
            label="用户"
            prop="userId"
          >
            <GridSelectU style="width: 177px;" labelName="userName" :disabled="videoCollectionState == 'check'" labelValue="id"
                :value="videoCollection.userId" :limit='1' size='small' placeholder='请选择用户' @getValue="getValueUser" :columns="USER_code" :searchs="USER_search" dataListUrl="/mpp/user/findList" entityBeanName="mppUser" queryEntityUrl="/mpp/user/get">
              </GridSelectU>
          </el-form-item>
          <el-form-item
            label="视频"
            prop="videoId"
          >
            <GridSelectVideo style="width: 177px;" labelName="videoDesc" :disabled="videoCollectionState == 'check'" labelValue="id"
                :value="videoCollection.videoId" :limit='1' size='small' placeholder='请选择视频' @getValue="getValueVideo" :columns="VIDEO_code" :searchs="VIDEO_search" dataListUrl="/video/video/findList" entityBeanName="videoVideo" queryEntityUrl="/video/video/get">
              </GridSelectVideo>
          </el-form-item>
        </el-form>
      </div>

      <div
        slot="footer"
        class="flex justify-end"
      >
        <el-button @click="closeDialog">关闭</el-button>
        <el-button
          type="primary"
          @click="submitForm"
          v-if="videoCollectionState != 'check'"
        >确定</el-button>
      </div>
    </el-dialog>
  </div>
  </div>
</template>

<script>
import { ArrowDownload24Regular, ArrowExportUp24Regular } from '@v2icons/fluent';
import { GridDots, Refresh, Printer, ArrowUp, ArrowDown, Search } from '@v2icons/tabler';
import { Edit24Regular, Delete24Regular, Eye24Regular } from '@v2icons/fluent';
import { exprotExcel, importTemplate, importDate, get, post, put, deleteFun } from '@/utils/request.js';
import GridSelectU from '@/components/gridselect';
import GridSelectVideo from '@/components/video'
import { USER, USER_SEARCH, VIDEO, VIDEO_SEARCH } from '@/utils/constant';
export default {
    components: {
        Edit24Regular,
        Delete24Regular,
        Eye24Regular,
        GridDots,
        Refresh,
        Printer,
        ArrowUp,
        ArrowDown,
        ArrowDownload24Regular,
        ArrowExportUp24Regular,
        Search,
        GridSelectU,
        GridSelectVideo,
    },
        watch: {
            checkState(val) {
                if (val == 'check') {
                    this.resetVideoCollectionList();
                    this.getVideoCollectionList(this.queryForm);
                    this.$emit('resetCheckState');
                } else if (val == 'reset') {
                    this.resetVideoCollectionList();
                    this.getVideoCollectionList();
                    this.$emit('resetCheckState');
                }
            }
        },
    data() {
            return {
                USER_code: USER,
                USER_search: USER_SEARCH,
                VIDEO_code: VIDEO,
                VIDEO_search: VIDEO_SEARCH,
                queryForm:{
                     userId: '', //用户Id
                     videoId: '', //视频Id
                },
                loading: false,
                showDialog: false,
                isImportDate: false,
                isSearch: false,
                pageSize: 10,
                currentPage: 1,
                totalNum: 0,
                currentUserId: '',
                videoCollectionState: 'add',
                videoCollectionStates: {
                    add: '新建收藏',
                    check: '查看收藏',
                    edit: '修改收藏'
                },

                multipleSelection: [],
                videoCollectionList: [],
                videoCollection: {
                    userId: '', //用户Id
                    videoId: '', //视频Id
                },
                btnLoading: false,

                rules: {
                    userId: [{ required: true, message: '用户Id不能为空', trigger: 'blur' }],
                    videoId: [{ required: true, message: '视频Id不能为空', trigger: 'blur' }],
                }
            };
        },
        created() {
            this.getVideoCollectionList();
        },
        methods: {
            // 选择视频
            getValueVideo(value){
              this.videoCollection.videoId = value
              console.log(this.videoCollection.videoId)
            },
            getSeachValueVideo(value){
                this.queryForm.videoId = value
            },
            // 选择用户
            getValueUser(value) {
              this.videoCollection.userId = value
            },
            getSeacherValueUser(value){
                this.queryForm.userId = value
            },
            search(){
                this.isSearch = !this.isSearch;
            },
            resetVideoCollectionList() {
                this.pageSize = 10;
                this.currentPage = 1;
                this.videoCollectionList = [];
            },
            resetDialog() {
                this.videoCollectionState = 'add';
                this.showDialog = false;
                this.queryForm = {
                      userId: '', //用户Id
                      videoId: '', //视频Id
                };
                this.getVideoCollectionList();
            },
            closeDialog() {
                this.showDialog = false
                this.videoCollection = {
                      userId: '', //用户Id
                      videoId: '', //视频Id
                };
            },
            submitForm() {
                if (this.videoCollectionState == 'add') {
                    this.$refs.videoCollectionForm.validate((valid) => {
                        if (valid) {
                            console.log('submit');
                            post(`/video/collection/add`,{ ...this.videoCollection }).then((res) => {
                                if (res.success || res.code == 200) {
                                    this.$message({
                                        message: res.msg,
                                        type: 'success',
                                        duration: 2000,
                                    });
                                    this.resetVideoCollectionList();
                                    this.resetDialog();
                                    this.getVideoCollectionList();
                                }
                            });
                        }
                    });
                } else if (this.videoCollectionState == 'edit') {
                    this.$refs.videoCollectionForm.validate((valid) => {
                        if (valid) {
                            console.log('submit');
                            delete this.videoCollection.user;
                            delete this.videoCollection.video;
                            post(`/video/collection/edit`,{ ...this.videoCollection }).then((res) => {
                                if (res.success || res.code == 200) {
                                    this.$message({
                                        message: res.msg,
                                        type: 'success',
                                        duration: 2000
                                    });
                                    this.resetVideoCollectionList();
                                    this.resetDialog();
                                    this.getVideoCollectionList();
                                }
                            });
                        }
                    });
                }
            },
            addVideoCollection() {
                this.showDialog = true;
                this.videoCollectionState = 'add';
            },
            checkVideoCollection(videoCollectionId) {
                console.log(videoCollectionId);
                this.currentVideoCollectionId = videoCollectionId;

                this.getVideoCollectionById();
                this.showDialog = true;
                this.videoCollectionState = 'check';
            },
            editVideoCollection(videoCollectionId) {
                console.log('videoCollection', videoCollectionId);
                if (videoCollectionId) {
                    this.currentVideoCollectionId = videoCollectionId;
                    this.getVideoCollectionById();
                } else {
                    this.videoCollection = { ...this.videoCollection, ...this.multipleSelection[0] };
                }

                this.showDialog = true;
                this.videoCollectionState = 'edit';
            },
            deleteVideoCollection(videoCollectionId) {
                let ids = '';
                if (videoCollectionId) {
                    ids = videoCollectionId;
                } else {
                    ids = this.multipleSelection.map((videoCollection) => videoCollection.id).join(',');
                }
                console.log({ ids });
                this.$confirm('确定删除所选项吗？', '提示', {
                    type: 'warning'
                })
                    .then(() => {
                        deleteFun(`/video/collection/delete`,{ ids }).then((res) => {
                            if (res.success || res.code == 200) {
                                this.$message({
                                    message: res.msg,
                                    type: 'success',
                                    duration: 2000
                                });
                                this.resetVideoCollectionList();
                                this.getVideoCollectionList();
                            }
                        });
                    })
                    .catch(() => {});
            },
            refreshVideoCollectionList() {
                this.resetVideoCollectionList();
                this.getVideoCollectionList();
            },
            getVideoCollectionList(query = {}) {
                this.loading = true;
                get(`/video/collection/findList`,{  ...this.queryForm, pageNum: this.currentPage, pageSize: this.pageSize }).then((res) => {
                    this.loading = false;
                    if (res.success || res.code == 200) {
                        this.videoCollectionList = res.page.list;
                        this.totalNum = res.page.total;
                    }
                });
            },
            getVideoCollectionById() {
                get(`/video/collection/get`,{ id: this.currentVideoCollectionId }).then((res) =>{
                    if(res.success || res.code == 200){
                      this.videoCollection = { ...this.videoCollection, ...res.videoCollection };
                    }
                });
            },
            /**
             * 导出信息
             */
            exportVideoCollectionList() {
                //this.btnLoading = true;
                exprotExcel(`/video/collection/export`, {...this.queryForm});
            },
            /**
             * 导出模板
             */
            importTemplate() {
                this.btnLoading = true;
                importTemplate(`/video/collection/importTemplate`, this.btnLoading);
            },
            /**
             * 导入数据
             */
            isImport() {
                this.isImportDate = !this.isImportDate;
            },
            upload(params){
              const file = params.file;
              const formData = new FormData();
              formData.append('file', file);
              console.log({ formData });
              importDate(`/video/collection/importData`,formData);
              this.refreshVideoCollectionList();
            },
            handleSelectionChange(value) {
                console.log(value);
                this.multipleSelection = value;
            },
            currentChange(page) {
                this.currentPage = page;
                this.getVideoCollectionList();
            },
            sizeChange(size) {
                this.pageSize = size;
                this.getVideoCollectionList();
            }
        }

};
</script>

<style lang="scss" scoped>
::v-deep .el-dialog__header {
  border-bottom: 1px solid #eee;
  padding: 15px 20px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  button{
    display: flex;
    align-items: center;
    justify-content: center;
  }
}
.operation {
    display: flex;
    align-items: center;
    justify-content: center;
    color: #409eff;
    font-size: 12px;

    & > div {
        display: flex;
        align-items: center;
        padding: 0 5px;
        cursor: pointer;
    }

    .operation-label {
        margin-left: 3px;
    }
}
</style>